import { render } from "./ShippingServicePickupIndex.vue?vue&type=template&id=e1228f1a"
import script from "./ShippingServicePickupIndex.vue?vue&type=script&lang=js"
export * from "./ShippingServicePickupIndex.vue?vue&type=script&lang=js"

import "./ShippingServicePickupIndex.vue?vue&type=style&index=0&id=e1228f1a&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__